<template>
  <div class="assignment-pdf">
    <div class="header">
      <div>Assignment</div>
      <div>Reference# {{ assignment.reference_number }}</div>
    </div>
    <div><label>Comment on this version:</label>{{ assignment.created_comment }}</div>
    <div class="pdf-formatter">
      <div class="left-section">
        <div class="contractor">
          <div class="name">{{ assignment.contractor.contractor_name }}</div>
          <div><label>Payroll#:</label> {{ assignment.payroll_number }}</div>
          <div><label>Entity:</label> {{ contractorEntity(assignment.contractor.entity) }}</div>
          <div><label>Pay to</label> {{ assignment.pay_to_name }}</div>
          <div>{{ assignment.contractor ? assignment.contractor.line1 : '' }}</div>
          <div>{{ assignment.contractor ? assignment.contractor.line2 : '' }}</div>
          <div>{{ assignment.contractor ? assignment.contractor.city : '' }}</div>
          <div>{{ assignment.contractor ? assignment.contractor.province_abbr : '' }}</div>
          <div>{{ assignment.contractor ? assignment.contractor.postal_code : '' }}</div>
          <div>
            <label>Phone</label>
            {{
              assignment.contractor.phone1
                ? assignment.contractor.phone1 + ' (' + assignment.contractor.phone1_type + ')'
                : ''
            }}
          </div>
          <div><label>Email</label> {{ assignment.contractor.email }}</div>
          <div><label>HST</label> {{ assignment.contractor.hst }}</div>
          <div><label>Backcheck</label> {{ assignment.contractor.backcheck_date }}</div>
        </div>
        <div v-if="assignment" class="client">
          <div class="name">
            {{ assignment.client_name }}
          </div>
          <div><label>Credit Check</label>{{ assignment.credit_check }}</div>
          <div><label>Client #</label> {{ assignment.client_number }}</div>
          <div>
            <label>Bill To</label>
            {{ assignment.billingMethod ? assignment.billingMethod.attention : '' }}
          </div>
          <div>{{ assignment.billingMethod ? assignment.billingMethod.address_line1 : '' }}</div>
          <div>{{ assignment.billingMethod ? assignment.billingMethod.address_line2 : '' }}</div>
          <div>{{ assignment.billingMethod ? assignment.billingMethod.city : '' }}</div>
          <div><label>Work Location</label> {{ assignment.work_location_province_abbr }}</div>
          <div><label>Work Order #</label> {{ assignment.work_order_number }}</div>
          <div><label>Work Authorization #</label> {{ assignment.work_authorization }}</div>
          <div><label>WOs & POs</label></div>
          <div v-for="item in assignment.purchaseOrderDetails" :key="item.id">
            {{ item.work_order_number + ' ' + item.purchase_order_number }}
          </div>
          <div><label>Approver Managers</label></div>
          <div v-for="item of assignment.stakeholderClientContacts" :key="item.user_id">
            <label>{{ item.display_name }}</label
            ><span class="email-room"> </span><font-awesome-icon icon="envelope" />
            {{ item.email }}
          </div>
        </div>
        <div :class="assignment.ibmExtraInfo ? 'extraInfoRates rates' : 'rates'">
          <div>
            <label>Rate Type</label><br />
            <label>Pay Rate</label><br />
            <label>Bill Rate</label><br />
            <label>Hour Range</label><br />
          </div>
          <div v-for="item of assignment.rates" :key="item.id" class="rate-types">
            {{ item.rate_code }}<br />
            {{ '$' + item.amount_pay }}<br />
            {{ '$' + item.amount_bill }}<br />
            {{ item.hour_range }}<br />
          </div>
        </div>
      </div>

      <div class="right-section">
        <div class="assignment">
          <div>
            <div class="assignment-header">
              <label>Branch</label> {{ assignment.branch_name }}
              {{ assignment.division_abbr ? assignment.division_abbr : '' }}
              <span>{{ assignment.department_code ? assignment.department_code : '' }}</span>
              <div :class="assignmentColor">{{ assignment.status }}</div>
            </div>
          </div>
          <div><label>Start Date</label> {{ assignment.start_date }}</div>
          <div><label>Stop Date</label> {{ assignment.stop_date }}</div>
          <div><label>Occupation </label>{{ assignment.occupation }}</div>
          <div>
            <label>Submittal Period </label
            >{{ assignment.submittal_period_type | readable | camelCase }}
          </div>
          <div>
            <label>Pay Period </label>{{ assignment.pay_period_type | readable | camelCase }}
          </div>
          <div><label>Submittals </label>{{ assignment.time_sheet_submittal | readable }}</div>
          <div>
            <label>Pay Stubs </label>{{ assignment.deposit_slip_access | readable | camelCase }}
          </div>
          <div>
            <label>Expenses </label>{{ assignment.expense_submittal | readable | camelCase }}
          </div>
          <div>
            <label>Payrollee </label>{{ displayYesOrNo(assignment.is_referral) }}
            {{ assignment.payrollee_code }}
          </div>
          <div>
            <label>Burden </label>{{ assignment.burden + '%' }}
            {{ isClerical(assignment.is_clerical) }}
          </div>
          <div><label>Rebate </label>{{ currentRebate }}</div>
          <div><label>Schedule F </label>{{ assignment.schedule_f | readable | camelCase }}</div>
          <div>
            <label>Asset Numbers </label
            >{{ assignment.asset_numbers ? assignment.asset_numbers : '' }}
          </div>
          <label>Account Managers</label>
          <div v-for="item of assignment.stakeholderCommissions" :key="item.index">
            {{ item.commission_type == 'ACCOUNT_MANAGER' ? stakeHolderDisplay(item) : '' }}
          </div>
          <label>Recruiters</label>
          <div v-for="item of assignment.stakeholderCommissions" :key="item.index">
            {{ item.commission_type == 'RECRUITER' ? stakeHolderDisplay(item) : '' }}
          </div>
          <label>Commission Overrides</label>
          <div v-for="item of assignment.stakeholderCommissions" :key="item.index">
            {{ item.commission_type == 'OVERRIDE' ? stakeHolderDisplay(item) : '' }}
          </div>
        </div>
        <!-- <br /> -->
        <div class="general-comments">
          <div class="name">General Comments</div>
          {{ assignment.general_comments ? assignment.general_comments : 'None' }}
        </div>
        <!-- <br /> -->
        <div class="external-comments">
          <div class="name">External Comments</div>
          {{ assignment.external_notes ? assignment.external_notes : 'None' }}
        </div>
        <div class="payment-comments">
          <div class="name">Payment Comments</div>
          {{ assignment.pay_comments ? assignment.pay_comments : 'None' }}
        </div>
        <div class="billing-comments">
          <div class="name">Billing Comments</div>
          {{ assignment.billing_comments ? assignment.billing_comments : 'None' }}
        </div>
      </div>
    </div>
    <div v-if="assignment.ibm_extra_info === 'Required'" class="footer" />
    <div v-if="assignment.ibm_extra_info === 'Required'" class="extra-info">
      <div class="header">
        <div>Assignment</div>
        <div>Reference# {{ assignment.reference_number }}</div>
      </div>
      <div class="name">Additional Information for IBM Contracts</div>
      <div class="hire-skill-status">
        <div class="hire-type">
          <label>Hire Type</label>
          <div>{{ assignment.ibmExtraInfo.hire_type }}</div>
        </div>
        <div class="skill-type">
          <label>Skill Type</label>
          <div>{{ assignment.ibmExtraInfo.skill_type }}</div>
        </div>
        <div class="referral-status">
          <label>Referral Status</label>
          <div>{{ assignment.ibmExtraInfo.referral_status }}</div>
        </div>
      </div>
      <br />
      <div class="addtnl-info">
        <div class="name">Initial Information for Purchasing</div>
        <div><label>CSA ?</label>{{ displayYesOrNo(assignment.ibmExtraInfo.is_csa) }}</div>
        <div><label>VOD ?</label>{{ displayYesOrNo(assignment.ibmExtraInfo.is_vod) }}</div>
        <div><label>CSA / PRF</label>{{ assignment.ibmExtraInfo.csa }}</div>
        <div><label>Skill 1 </label>{{ assignment.ibmExtraInfo.skill1 }}</div>
        <div><label>Skill 2 </label>{{ assignment.ibmExtraInfo.skill2 }}</div>
        <div><label>Skill 3 </label>{{ assignment.ibmExtraInfo.skill3 }}</div>
        <div><label>PO Start </label>{{ assignment.ibmExtraInfo.po_start }}</div>
        <div><label>PO Stop </label>{{ assignment.ibmExtraInfo.po_stop }}</div>
        <div><label>Region </label>{{ assignment.ibmExtraInfo.region }}</div>
        <div><label>City </label>{{ assignment.ibmExtraInfo.city }}</div>
      </div>
      <br />
      <div class="family-taxonomy">
        <div class="name">Family Taxonomy</div>
        <div><label>Services Type</label>{{ assignment.ibmExtraInfo.services_type }}</div>
        <div>
          <label>Family Taxonomy Title </label>{{ assignment.ibmExtraInfo.family_taxonomy_title }}
        </div>
        <div><label>Job Role </label>{{ assignment.ibmExtraInfo.job_role }}</div>
        <div><label>Comm Code </label>{{ assignment.ibmExtraInfo.comm_code }}</div>
        <div>
          <label>Skill Level </label
          >{{ selectedSkillLevel(assignment.ibmExtraInfo.skill_level_id) }}
        </div>
        <div><label>Matrix Bill Rate </label>{{ assignment.ibmExtraInfo.matrix_rate }}</div>
        <div>
          <label>Line of Business </label
          >{{ selectedLineOfBusiness(assignment.ibmExtraInfo.ibm_line_of_business_id) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AssignmentDetailsGetters } from '../assignment-details/assignment-details.keys';
import { AppGetters } from '@/app/app.keys';
export default {
  name: 'AssignmentDetailsPdf',
  computed: {
    assignment() {
      return this.$store.getters[AssignmentDetailsGetters.CurrentAssignment];
    },
    currentRebate() {
      const rebate = this.$store.getters[AppGetters.ClientRebates].filter(
        item => item.id === this.assignment.rebate_id
      )[0];
      return rebate ? rebate.id + '% ' + rebate.code : '';
    },
    assignmentColor() {
      switch (this.assignment.status) {
        case 'ACTIVE_ONLINE':
          return 'active-online';
        case 'ACTIVE_OFFLINE':
          return 'active-offline';
        case 'DRAFT':
          return 'draft';
        case 'SUBMITTED':
          return 'submitted';
      }
      return 'draft';
    }
  },
  methods: {
    isClerical(clericalFlag) {
      return clericalFlag ? 'Clerical' : 'Non-Clerical';
    },
    displayYesOrNo(flag) {
      return flag ? 'Yes' : 'No';
    },
    stakeHolderDisplay(stakeHolder) {
      switch (stakeHolder.commission_type) {
        case 'ACCOUNT_MANAGER':
        case 'RECRUITER':
          return `
            ${stakeHolder.display_name} 
            #
            ${stakeHolder.commission_number}
             @ 
            ${stakeHolder.split}
            %`;
        case 'OVERRIDE':
          return stakeHolder.display_name + '#' + stakeHolder.commission_number;
      }
    },
    contractorEntity(entity) {
      switch (entity) {
        case 'SUPPLIER':
          return 'Supplier';
        case 'CONSTRUCTION':
          return 'Construction';
        case 'STAFF':
          return 'Staff';
        case 'SOLE':
          return 'Sole Proprietor';
        case 'INC':
          return 'Incorporation';
        default:
          return entity;
      }
    },
    selectedLineOfBusiness(id) {
      let [lineOfBusiness] = this.$store.getters[AppGetters.IbmLineOfBusiness].filter(
        lob => lob.id == id
      );
      return lineOfBusiness ? lineOfBusiness.name : null;
    },
    selectedSkillLevel(id) {
      if (this.assignment.ibmExtraInfo.services_type && id) {
        let [skillLevel] = this.$store.getters[AppGetters.IbmSkillLevel].filter(
          skill => skill.id == id
        );
        return skillLevel.name;
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
@media print {
  .email-room {
    margin-right: 10px;
  }
  label {
    font-weight: bold;
  }
  .pdf-formatter {
    display: flex;
    flex-direction: row;
  }
  .header {
    display: flex;
    flex-direction: row;
    color: $grey;
    padding-top: 0px;
    padding-bottom: 10px;
    justify-content: space-between;
    font-size: 1rem;
  }
  .left-section {
    display: flex;
    flex-direction: column;
    width: 55%;
  }

  .left-section > * {
    margin: 0 0 0 0;
  }

  .left-section > div {
    margin: 3px 0 3px 0;
  }

  .contractor {
    border: 1px solid $black;
    padding: 10px;
  }
  .name {
    padding-bottom: 10px;
    font-weight: bold;
  }
  .client {
    border: 1px solid $black;
    padding: 10px;
  }
  .assignment {
    border: 1px solid $black;
    padding: 10px;
  }
  /*.rates {
    display: flex;
    flex-wrap: wrap;
  }

.rate-types {
    border: 1px solid $black;
    padding: 5px;
  }*/

  .general-comments {
    border: 1px solid $black;
    padding: 10px;
  }
  .external-comments {
    border: 1px solid $black;
    padding: 10px;
  }
  .payment-comments {
    border: 1px solid $black;
    padding: 10px;
  }
  .billing-comments {
    border: 1px solid $black;
    padding: 10px;
  }
  .family-taxonomy {
    border: 1px solid $black;
    padding: 10px;
    width: 50%;
  }
  .addtnl-info {
    border: 1px solid $black;
    padding: 10px;
    width: 30%;
    align-items: center;
  }
  .right-section {
    display: flex;
    flex-direction: column;
    padding-left: 25px;
    width: 50%;
  }

  .right-section > div {
    margin: 3px 0 3px 0;
  }
  .footer {
    page-break-after: always;
  }

  .hire-skill-status {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .assignment-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      background-color: $blue;
      color: $white;
    }
  }

  .active-online {
    background-color: $green;
    color: $white;
  }

  .active-offline {
    background-color: $purple;
    color: $white;
  }

  .draft {
    background-color: $grey;
    color: $white;
  }

  .submitted {
    background-color: $orange;
    color: $white;
  }

  .department-code {
    color: $blue;
  }

  div {
    padding-bottom: 2px;
    font-size: 0.9rem;
  }
}
.email-room {
  margin-right: 10px;
}

label {
  font-weight: bold;
}

.pdf-formatter {
  display: flex;
  flex-direction: row;
}
.header {
  display: flex;
  flex-direction: row;
  color: $grey;
  padding-top: 0px;
  padding-bottom: 10px;
  justify-content: space-between;
  font-size: 1rem;
}
.left-section {
  display: flex;
  flex-direction: column;
  width: 55%;
  // padding-right: 25px;
}

.left-section > div {
  margin: 3px 0 3px 0;
}
.contractor {
  border: 1px solid $black;
  padding: 10px;
}
.name {
  padding-bottom: 10px;
  font-weight: bold;
}
.client {
  border: 1px solid $black;
  padding: 10px;
}
.assignment {
  border: 1px solid $black;
  padding: 10px;
}
.rates {
  display: flex;
  flex-wrap: wrap;
}

.rate-types {
  border: 1px solid $black;
  margin-left: 15px;
  padding: 5px;
}
.rate-types:nth-child(5n) {
  margin-right: 0;
}
.rate-types:nth-child(5n + 1) {
  clear: left; /* Forces a new row */
}

.general-comments {
  border: 1px solid $black;
  padding: 10px;
}
.external-comments {
  border: 1px solid $black;
  padding: 10px;
}
.payment-comments {
  border: 1px solid $black;
  padding: 10px;
}
.billing-comments {
  border: 1px solid $black;
  padding: 10px;
}
.family-taxonomy {
  border: 1px solid $black;
  padding: 10px;
  width: 50%;
}
.addtnl-info {
  border: 1px solid $black;
  padding: 10px;
  width: 30%;
  align-items: center;
}
.right-section {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  padding-left: 25px;
  width: 50%;
}
.right-section > div {
  margin: 3px 0 3px 0;
}
.footer {
  page-break-after: always;
}

.hire-skill-status {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.assignment-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.active-online {
  background-color: $green;
  color: $white;
}

.active-offline {
  background-color: $purple;
  color: $white;
}

.draft {
  background-color: $grey;
  color: $white;
}

.submitted {
  background-color: $orange;
  color: $white;
}

.department-code {
  color: $blue;
}

.assignment-pdf {
  margin: 1% 5%;
}

div {
  margin: 0 0 0 0;
  padding-bottom: 2px;
  font-size: 0.9rem;
}
</style>
